module.exports = {
      id: "strategy-usage",
      viewBox: "0 0 13.247 22.012",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#strategy",
      toString: function () {
        return this.url;
      }
    }